/** Targeted renderer → main invoke: whether an IME composition is active in the overlay chat input. */
export const OVERLAY_CHAT_INPUT_COMPOSING_EVENT = 'overlay:chat-input-composing'

export type OverlayWindowLevel = 'floating' | 'screen-saver'

export interface OverlayWindowLevelInputs {
  isMac: boolean
  isWindowFocused: boolean
  isChatInputFocused: boolean
  isChatInputComposing: boolean
  isMiniNotched: boolean
}

/**
 * macOS draws IME candidate windows and text-replacement bubbles below the
 * `screen-saver` level (electron/electron#29459). They can only appear while
 * the overlay is the key window with the chat input focused, so in that state
 * the overlay sits at `floating`, above normal app windows but below the
 * system text popups. Otherwise it stays at `screen-saver`, above fullscreen
 * apps, the menu bar, and meeting tools.
 *
 * `floating` is also below the menu bar, and a notched Mini lives inside that
 * band. Dropping hides it behind the menu bar and hands its clicks to the menu
 * bar. The candidate window is below the menu bar too, so no level serves
 * both. A notched Mini yields only while a composition is active, the only
 * time a candidate window exists.
 */
export function resolveOverlayWindowLevel({
  isMac,
  isWindowFocused,
  isChatInputFocused,
  isChatInputComposing,
  isMiniNotched,
}: OverlayWindowLevelInputs): OverlayWindowLevel {
  if (!isMac || !isWindowFocused || !isChatInputFocused) {
    return 'screen-saver'
  }
  if (isMiniNotched && !isChatInputComposing) {
    return 'screen-saver'
  }
  return 'floating'
}
